// **************************
// *** AgendamentosExcluidos excluidos.jsx 
// *** autor: Walcledson de Paula
// *** MVinfo Sistemas & Automação
// *** 17/06/24 | 15:32h
// *** 4/7/24 | 11h20 → acrescentado o token criptografado
// **************************



import { useEffect, useState } from "react";
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import apiaxios from "../../../../Services/apiaxios.js";
import { decrypt } from "../../../../Services/cryptoUtils.js";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import handleApiError from "../../../../Services/apiErrorHandler.js";

import Menu from "../../components/Menu/menu.jsx";
import CardAgendamentos from "../../components/Agendamentos/agendamentos.jsx";
import Footer from "../../components/Footer/footer.jsx";

import './pendentes.css';

function AgendamentosExcluidos() {
    const getInitialUserData = () => {
        const encryptedUser = localStorage.getItem('tokenacw');
        if (encryptedUser) {
            try {
                const decryptedUser = decrypt(encryptedUser);
                return {
                    userId: decryptedUser.id_usuario || 0,
                    tam_pagina: decryptedUser.TAMANHO_PAGINA || 10
                };
            } catch (error) {
                console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
                return { userId: 0, tam_pagina: 0 };
            }
        }
        return { userId: 0, tam_pagina: 0 };
    };

    const initialUserData = getInitialUserData();
    const [tamanho_pagina, setTamanho_pagina] = useState(initialUserData.tam_pagina);
    const [id_usuario, setId_usuario] = useState(initialUserData.userId);

    const [nenhumAgendamentoExcluidoEncontrado, setNenhumAgendamentoExcluidoEncontrado] = useState(false);
    const [loading, setLoading] = useState(false);
    const [agendamentos, setAgendamentos] = useState([]);
    const [pagina, setPagina] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const MySwal = withReactContent(Swal);

    useEffect(() => {
        atualizarAgendamentos(pagina);
    }, [pagina]);

    const atualizarAgendamentos = (pagina) => {
        setLoading(true);
        const url = `reserva/listar?id_usuario=${id_usuario}&pagina=${pagina}&tamanho_pagina=${tamanho_pagina}&id_status1=7`;
        apiaxios.get(url)
            .then((response) => {
                setLoading(false);

                if (response.data.retorno) {
                    alert('Erro ao carregar agendamentos: ' + response.data.retorno);
                } else {
                    if (response.data.length === 0) {
                        setNenhumAgendamentoExcluidoEncontrado(true);
                        MySwal.fire({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            icon: 'info',
                            title: 'Nenhum agendamento pendente encontrado neste momento...'
                        });
                        setHasMore(false);

                    } else {
                        setNenhumAgendamentoExcluidoEncontrado(false);
                        setAgendamentos(prevDados => [...prevDados, ...response.data]);
                        if (response.data.length < tamanho_pagina) {
                            setHasMore(false);
                        }
                    }
                }
            })
            .catch(error => {
                setLoading(false);
                handleApiError(error);
            });
    };

    

        

    return (
        <>
            <div className="topo-margin">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <Menu page="agendamentospendentes" />
                        </div>
                        <div className="col py-2 me-3">
                            <div className="container-fluid">
                                <h1 className="text-center">Agendamentos Pendentes</h1>
                                <div className="row">
                                    {loading && (
                                        <div className="loading-spinner-container">
                                            <Oval color="#00BFFF" height={80} width={80} />
                                        </div>
                                    )}
                                    {nenhumAgendamentoExcluidoEncontrado ? (
                                        <div className="alert alert-danger mt-10" role="alert">
                                            Nenhum "Agendamento Pendente" disponível neste momento...
                                        </div>
                                    ) : (
                                        <div className="box-agendamentos">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Id.Reserva</th>
                                                        <th>Descrição</th>
                                                        <th>Nome Empresa</th>
                                                        <th>Endereço Empresa</th>
                                                        <th>Fone Empresa</th>
                                                        <th>Data</th>
                                                        <th>Hora</th>
                                                        <th>Valor</th>
                                                        <th className="text-right">Status</th>
                                                        {/* <th>Ações</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/* {agendamentos.filter(agendamento => agendamento.ID_STATUS === 7).map(agendamento => ( */}
                                                    {/* {agendamentos.map(agendamento => ( */}
                                                    {agendamentos.map((agendamento, index) => (
                                                        <CardAgendamentos
                                                            // key={agendamento.ID_RESERVA}
                                                            key={`${agendamento.ID_RESERVA}-${index}`}
                                                            agendamento={{
                                                                agendamento_id: agendamento.ID_RESERVA,
                                                                agendamento_descricao: agendamento.DESCRICAO,
                                                                agendamento_nome: agendamento.NOME,
                                                                agendamento_data: agendamento.DATA_RESERVA,
                                                                agendamento_hora: agendamento.HORA,
                                                                agendamento_vr: agendamento.VALOR,
                                                                agendamento_endereco: `${agendamento.ENDERECO} ${agendamento.BAIRRO} - ${agendamento.CIDADE}`,
                                                                agendamento_fone: agendamento.FONE,
                                                                agendamento_status: `${agendamento.ID_STATUS} : ${agendamento.ST_DESCRICAO}`
                                                            }}
                                                            showExcluir={false}
                                                            showAvaliar={false}
                                                            showMotivo={false}
                                                            // handleExcluir={handleExcluir}
                                                        />
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                           
                                    )}
                                </div>
                                {hasMore && (
                                    <div className="load-more">
                                        <button onClick={() => setPagina(prevPagina => prevPagina + 1)}>Carregar mais</button>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default AgendamentosExcluidos;